<template>
  <div>
    <div class="result-page-container">
      <div class="result-page-section">
        <div class="result-page-content">
          <Carousel :per-page="1" :mouse-drag="handleResize()">
            <Slide
              v-for="resultItem in results.ResultList"
              :key="resultItem.ProductName"
              class="result-page-item-wrapper"
            >
              <div class="result-page-item">
                <img :src="resultItem.ProductPackshotImageUrl" alt="" />
              </div>
              <div class="result-page-item">
                <span>{{ resultItem.BrandLabel }}</span>
                <h2>{{ resultItem.ProductName }}</h2>
                <p>{{ resultItem.ProductShortDescription }}</p>
                <div class="buy-wrapper">
                  <a :href="resultItem.ProductItemUrl" class="detail-btn">{{ detaillabelData }}</a>
                  <a
                    v-if="
                      (resultItem.externalRetailerUrl == null ||
                        resultItem.externalRetailerUrl == '') &&
                      resultItem.hasShops == true
                    "
                    :shopdata="resultItem.SitecoreEretailersList.eretailershops"
                    class="buy-online"
                    @click="
                      commerceShops(
                        resultItem.SitecoreEretailersList.eretailershops,
                        true,
                        resultItem.ProductName,
                        resultItem.SitecoreEretailersList.descriptionText
                      );
                      getTaggingInfo(
                        pagecategoryData,
                        resultItem.BuyOnlineTaggingInfo.eventAction,
                        resultItem.BuyOnlineTaggingInfo.eventLabel
                      );
                    "
                    >{{ buyonlinelabelData }}</a
                  >
                  <a
                    v-else-if="resultItem.externalRetailerUrl != ''"
                    :href="resultItem.externalRetailerUrl"
                    class="buy-online"
                    target="_blank"
                    @click="
                      getTaggingInfo(
                        pagecategoryData,
                        resultItem.BuyOnlineTaggingInfo.eventAction,
                        resultItem.BuyOnlineTaggingInfo.eventLabel
                      )
                    "
                    >{{ buyonlinelabelData }}</a
                  >
                </div>
              </div>
            </Slide>
          </Carousel>
        </div>
        <button class="diagnose-btn" @click="getQuestionUrl()">{{ diagnoseagainData }}</button>
      </div>
      <span class="border-box"></span>
      <span class="border-box"></span>
    </div>

    <div class="commerceConnector" :class="{ '-expanded': expandPanel }" :aria-hidden="ariaHidden">
      <div
        v-if="expandPanel"
        class="commerceConnector__overlay"
        @click="commerceShops('', false)"
      ></div>
      <div
        class="commerceConnector__layout"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-heading"
      >
        <button
          ref="commerceConnectorCloseButton"
          class="commerceConnector__close commerceConnector__tabIndex"
          tabindex="-1"
          @click="commerceShops('', false)"
          @keyup.esc="commerceShops('', false)"
        >
          <svg class="icon" role="img" aria-labelledby="closeCommerceConnector">
            <title id="closeCommerceConnector">Close window</title>
            <svg id="close" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.3 10.5l6.6 6.6c.8.8.8 2 0 2.8-.8.8-2 .8-2.8 0l-6.6-6.6-6.6 6.6c-.8.8-2 .8-2.8 0-.8-.8-.8-2 0-2.8l6.6-6.6-6.6-6.6c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l6.6 6.6 6.6-6.6c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-6.6 6.6z"
              ></path>
            </svg>
          </svg>
        </button>
        <form>
          <div class="commerceConnector__wrapper">
            <fieldset>
              <template>
                <legend class="commerceConnector__description">
                  <h1 id="modal-heading">
                    <strong>{{ descriptionProduct }}</strong>
                    {{ descriptionText }}
                  </h1>
                </legend>
                <ul class="commerceConnector__shops">
                  <li
                    v-for="shop in eretailershops"
                    :key="shop.title"
                    class="commerceConnector__item"
                  >
                    <a
                      :href="shop.link"
                      class="commerceConnector__radioLabel commerceConnector__tabIndex"
                      target="_blank"
                      @click="
                        getRetailerUrl(
                          shop.link,
                          shop.buyButton,
                          shop.taggingInfo.eventAction,
                          shop.taggingInfo.eventLabel
                        )
                      "
                    >
                      <img :src="shop.Image" alt="" class="commerceConnector__logo" />
                      {{ shop.title }}
                    </a>
                  </li>
                </ul>
              </template>
            </fieldset>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { AnalyticsHandler } from '../../../../../../Foundation/Core/code/Scripts/analyticsHandler/AnalyticsHandler';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'PrResult',
  components: {
    Carousel,
    Slide,
  },
  props: {
    resultsData: { type: Object, required: true },
    buyonlinelabelData: { type: String, required: false },
    detaillabelData: { type: String, required: false },
    diagnoseagainData: { type: String, required: false },
    pagecategoryData: { type: String, required: false },
  },
  data() {
    return {
      results: this.resultsData,
      eretailershops: [],
      expandPanel: false,
      ariaHidden: true,
      productName: '',
      taggingUrl: '',
      descriptionProduct: '',
      descriptionText: '',
      eventAction: '',
      eventLabel: '',
    };
  },

  methods: {
    commerceShops: function (
      eretailershops,
      isConnectorOpened,
      descriptionProduct,
      descriptionText
    ) {
      this.eretailershops = eretailershops;
      this.descriptionProduct = descriptionProduct;
      this.descriptionText = descriptionText;
      if (isConnectorOpened) {
        this.ariaHidden = false;
        //this.focusCloseButton();
        document.querySelector('body').classList.add('noScroll', '-fixed');
      } else {
        this.ariaHidden = true;
        document.querySelector('body').classList.remove('noScroll', '-fixed');
      }
      this.expandPanel = isConnectorOpened;
    },
    handleResize() {
      return window.innerWidth <= 768;
    },
    getRetailerUrl(url, buyButton, eventAction, eventLabel) {
      this.taggingUrl = url;
      this.productName = buyButton;
      this.eventAction = eventAction;
      this.eventLabel = eventLabel;
    },
    getQuestionUrl() {
      let iOS = /iPad|iPhone/.test(navigator.userAgent) && !window.MSStream;
      if (iOS) {
        window.location.href = document.referrer;
      } else {
        window.history.go(-1);
      }
    },
    getTaggingInfo(pagecategory, action, label) {
      AnalyticsHandler.getAnalyticsHandler().push({
        type: 'userActionEvent',
        ecommerce: 'undefined',
        category: pagecategory,
        action: action,
        label: label,
      });
    },
  },
};
</script>
